module.exports = __webpack_public_path__ + "static/img/ARAW45_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAW45_1.png
// module id = drZO
// module chunks = 0